import React from 'react';

import { Box, Flex, Text } from '@chakra-ui/react';

import BaseImage from '../Base/BaseImage/BaseImage';

const CallAlfred = () => {
  return (
    <Flex
      as={'a'}
      href='tel:800253733'
      pos='fixed'
      bottom='0'
      w='full'
      bgColor={'imColor.primary'}
      justify='center'
      align='center'
      p='1'
      display={{ base: 'flex', lg: 'none' }}
    >
      <Box me='2' display='flex' boxSize='52px'>
        <BaseImage
          src={'/assets/img/global/call-alfred-mini.png'}
          alt='Call 800 Alfred'
          dimensions={[52, 52]}
        />
      </Box>
      <Box>
        <Text
          as={'button'}
          fontSize='22px'
          casing='uppercase'
          color='white'
          fontWeight='900'
        >
          call 800 alfred
        </Text>
      </Box>
    </Flex>
  );
};

export default CallAlfred;
